import { Pipe, PipeTransform } from '@angular/core';
import { CeidgStatus } from '../../../models/ceidg.model';

@Pipe({
  name: 'ceidgStatus',
  standalone: true
})
export class CeidgStatusPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): string {
    let result = '';
    switch(value) {
      case CeidgStatus.ACTIVE:
        result = 'Aktywny';
        break;
      case CeidgStatus.REMOVED:
        result = 'Wykreślony';
        break;
      case CeidgStatus.SUSPENDED:
        result = 'Zawieszony';
        break;
      case CeidgStatus.PENDING_START_OF_ACTIVITY:
        result = 'Oczekuje na rozpoczęcie działalności';
        break;
      case CeidgStatus.OPERATES_EXCLUSIVELY_AS_A_COMPANY:
        result = 'Wyłącznie w formie spółki';
        break;
      case CeidgStatus.TRANSFERRED_TO_NCR:
        result = 'Przeniesiony do KRS';
        break;

    }


    return result;
  }

}
